import { ConfigurationSourceDataMap } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import ConfigurationSourceDataItemForm from "@/components/forms/forms/source-data-configuration/ConfigurationSourceDataItemForm";
import MetadataContext from "@/contexts/data/MetadataContext";
import TrialContext from "@/contexts/data/TrialContext";
import ConfigurationSourceDataFormContext from "@/contexts/form/ConfigurationSourceDataFormContext";
import useItemConfiguration from "@/hooks/form/configuration/useItemConfiguration";
import useDebouncedValue from "@/hooks/utility/useDebouncedValue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, AlertTitle } from "@mui/material";
import { useScopedField } from "@ngt/forms-core";
import { FC, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";

const ConfigurationSourceDataItem: FC = () => {
    const { studyEventOid, caseReportFormOid, caseReportFormVersionOid, itemGroupName, itemName } = useParams();

    const { data: trial } = useContext(TrialContext);
    const { data: metadata } = useContext(MetadataContext);
    const { state: { value: configuration } } = useScopedField<ConfigurationSourceDataMap>('configuration', { value: true });
    const { state: { value: trialConfiguration } } = useScopedField<ConfigurationSourceDataMap>('trialConfiguration', { value: true });


    const {
        state: debouncedConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextConfigurationUpdate
    } = useDebouncedValue(configuration, 500);

    const {
        state: debouncedTrialConfiguration,
        doNotDebounceNextUpdate: doNoteDebounceNextTrialConfigurationUpdate
    } = useDebouncedValue(trialConfiguration, 500);

    const onLinkUpdate = useCallback(() => {
        doNoteDebounceNextConfigurationUpdate();
        doNoteDebounceNextTrialConfigurationUpdate();
    }, [doNoteDebounceNextConfigurationUpdate, doNoteDebounceNextTrialConfigurationUpdate]) 

    const { baseRoute } = useContext(ConfigurationSourceDataFormContext);

    const itemData = useItemConfiguration(
        metadata,
        debouncedTrialConfiguration ?? undefined,
        debouncedConfiguration ?? undefined,
        trial,
        debouncedConfiguration?.configuration?.id,
        studyEventOid,
        caseReportFormOid,
        caseReportFormVersionOid,
        itemGroupName,
        itemName,
        baseRoute
    );

    if (!itemData) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={AppSettings.icons.alertWarning} />}
                severity="warning"
            >
                <AlertTitle>Item Not Found</AlertTitle>
                The {studyEventOid} {caseReportFormOid} {caseReportFormVersionOid} {itemGroupName} {itemName} item was not found.
            </Alert> 
        )
    }

    return (
        <>
            <ConfigurationSourceDataItemForm
                data={itemData}
                onLinkUpdate={onLinkUpdate}
            />
        </>
    )
};

export default ConfigurationSourceDataItem;